import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Button } from 'reactstrap';

function ErrorPage({ error }) {
  return (
    <Container fluid className="vh-100">
      <Row className="flex-column justify-content-center vh-100 align-items-center mx-1">
        <p className="font-weight-bold h1 text-center text-white mb-5">
          Oups ! Une erreur est survenue
        </p>
        <p className="mb-5 h4 text-center text-white p-light">
          Retentez votre chance ultérieurement
        </p>
        <p className="p-light">{error.response.data.error}</p>
        <Link to="/">
          <Button color="warning" size="lg">
            Accueil
          </Button>
        </Link>
      </Row>
    </Container>
  );
}

export default ErrorPage;
